(() => {
  const EXPERIMENT_ID = 'twelveboards-hero-cta-v1';
  const QUERY_KEY = 'sb_cta';
  const STORAGE_KEY = 'sb:twelveboards-hero-cta-v1';
  const AUTO_ENABLED = false;

  const variants = {
    control: {
      label: null,
      className: null
    },
    drop: {
      label: 'SHOP THE NEW DROP',
      className: 'sb-cta--drop'
    },
    finder: {
      label: 'FIND YOUR BOARD',
      className: 'sb-cta--finder'
    },
    direct: {
      label: 'SHOP NEW BOARDS',
      className: 'sb-cta--direct'
    }
  };

  function emitEvent(eventName, variantId, link, forcedPreview) {
    const detail = {
      event: eventName,
      experiment_id: EXPERIMENT_ID,
      variant_id: variantId,
      surface: 'homepage_hero',
      destination: link.getAttribute('href') || '',
      page_path: window.location.pathname,
      forced_preview: forcedPreview
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, {
        experiment_id: detail.experiment_id,
        variant_id: detail.variant_id,
        surface: detail.surface,
        destination: detail.destination,
        page_path: detail.page_path,
        forced_preview: detail.forced_preview
      });
    }

    document.dispatchEvent(new CustomEvent('snowball:experiment', { detail }));
  }

  function chooseVariant() {
    const forced = new URLSearchParams(window.location.search).get(QUERY_KEY);
    if (forced && variants[forced]) {
      return { id: forced, forcedPreview: true };
    }

    if (!AUTO_ENABLED) return null;

    let saved = window.localStorage.getItem(STORAGE_KEY);
    if (!variants[saved]) {
      const ids = Object.keys(variants);
      saved = ids[Math.floor(Math.random() * ids.length)];
      window.localStorage.setItem(STORAGE_KEY, saved);
    }

    return { id: saved, forcedPreview: false };
  }

  function showReviewSlide(root, link) {
    const slide = link.closest('.hero-carousel__slide');
    if (!slide) return;

    const slides = Array.from(root.querySelectorAll('.hero-carousel__slide'));
    const index = slides.indexOf(slide);
    const dot = root.querySelectorAll('.hero-carousel__dot')[index];

    if (dot) dot.click();

    const pause = root.querySelector('.hero-banner__playpause[aria-label="Pause"]');
    if (pause) pause.click();
  }

  function activate() {
    if (window.location.pathname !== '/') return;

    const assignment = chooseVariant();
    if (!assignment) return;

    const root = document.querySelector('[data-sb-hero-experiment="' + EXPERIMENT_ID + '"]');
    if (!root) return;

    const link = root.querySelector('.hero-banner__btn[href*="/collections/snowboards"]');
    if (!link) return;

    const variant = variants[assignment.id];
    const label = link.querySelector('.hero-banner__btn-label');

    if (assignment.id !== 'control') link.classList.add('sb-cta');
    link.dataset.sbExperimentId = EXPERIMENT_ID;
    link.dataset.sbVariantId = assignment.id;

    if (variant.className) link.classList.add(variant.className);
    if (variant.label && label) label.textContent = variant.label;
    if (assignment.forcedPreview) showReviewSlide(root, link);

    emitEvent('snowball_experiment_exposure', assignment.id, link, assignment.forcedPreview);

    link.addEventListener('click', () => {
      emitEvent('snowball_experiment_goal', assignment.id, link, assignment.forcedPreview);
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate, { once: true });
  } else {
    activate();
  }
})();